module.exports = __webpack_public_path__ + "static/img/arrow-down-orange.2dcce738.svg";